module.exports = __webpack_public_path__ + "files/04cb18e4d5a185ce462f0f08710793a3.png";